import React, { FC } from 'react'
import { Paper } from '@e3dc-react/shell/Elements/Paper'
import { Typography, Box } from '@mui/material'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(theme => ({
  container: {
    paddingInline: theme.spacing(3),
  },
}))

interface PaperContainerProps {
  title: string
  children?: React.ReactNode
  contentClassName?: string
}

/**
 * This component represents a wrapper component for both parts on the installation details page
 * @returns PaperContainer Component
 **/
const PaperContainer: FC<PaperContainerProps> = ({ title, children, contentClassName }) => {
  const { classes, cx } = useStyles()

  return (
    <Paper
      title={
        <Typography variant={'h2'} component={'span'}>
          {title}
        </Typography>
      }
    >
      <Box className={cx(classes.container, contentClassName)}>{children}</Box>
    </Paper>
  )
}

export default PaperContainer
